import React from 'react';
import Cleave from "cleave.js/react";
import {Controller} from "react-hook-form";
import validation from "../../validation";

const AccountAddressFormPhoneInput = ({
    control={},
    setValue=()=>{},
    errors={},
    isRequired=true,
    inputClassName='',
}) => {
    const phoneValidationRules = {
        required: isRequired,
        maxLength: 12,
        minLength: 12,
        validate: {
            isValidPhone: (value)=>{
                const phone = value.replace(/\D/g,'') || '';
                return !!phone && !(phone.substring(0, 1) === '0') && !(phone.substring(0, 1) === '1') && phone.length === 10;
            },
        },
    };

    const onPhoneChange = (e)=>{
        const value = String(e?.target?.value || '').replace(/^[01]*/, '');
        setValue('phone', value, {
            shouldValidate: !!Object.keys(errors).length,
            shouldDirty: true,
            shouldTouch: true
        });
    };
    return (
        <Controller
            name="phone"
            control={control}
            rules={phoneValidationRules}
            render={({field: { onBlur, value, },}) =>
                <Cleave id="account-form--phone"
                        name="phone"
                        options={{delimiter: '.',blocks: [3, 3, 4], numericOnly: true, }}
                        value={value}
                        onBlur={onBlur}
                        onChange={onPhoneChange}
                        className={inputClassName} />
            } />
    );
};

export default AccountAddressFormPhoneInput;